import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { bundledBaseline } from '../theme/bundledPresentation';
import { PresentationContext } from '../theme/PresentationContext';
import { validateAppScreens } from './validation';
import { readAppScreens, resolveScreenDefaults, type AppScreens } from './model';

export function useAppScreens() {
  const authorized = useSelector((state: RootState) => state.session?.authorized);
  const snapshot = useContext(PresentationContext);
  const stored = useSelector((state: RootState) => state.session?.settings?.app_screens);
  const enabled = useSelector((state: RootState) => state.featureFlags?.fetched && state.featureFlags.flags?.app_studio_enabled === true);
  const override = stored != null && !validateAppScreens(stored).errors.length ? stored as AppScreens : null;
  const value = snapshot ? snapshot.screens : enabled ? resolveScreenDefaults(bundledBaseline.screens, override) : bundledBaseline.screens;
  return useMemo(() => readAppScreens(authorized ? value : null), [authorized, value]);
}
